export const formatTableCellValue = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '—';
  }

  if (typeof value === 'string') {
    return value.length ? value : '—';
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  if (Array.isArray(value)) {
    if (value.length === 0) {
      return '—';
    }

    const isPrimitiveArray = value.every(
      (item) => item === null || ['string', 'number', 'boolean'].includes(typeof item),
    );

    if (isPrimitiveArray) {
      const joined = value
        .map((item) => (item === null || item === undefined ? '' : String(item)))
        .filter(Boolean)
        .join(', ');
      return joined.length ? joined : '—';
    }

    return JSON.stringify(value);
  }

  if (typeof value === 'object') {
    return JSON.stringify(value);
  }

  return String(value);
};
